import React, { useState, useEffect } from 'react';
import './Spec.scss';

const Spec = ({ setProductPosition }) => {
  const [target, setTarget] = useState(null);

  const onIntersect = async ([entry], observer) => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      setProductPosition(target.id);
      observer.observe(entry.target);
    }
  };

  useEffect(() => {
    let observer;
    if (target) {
      observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });
      observer.observe(target);
    }
    return () => observer && observer.disconnect();
  });

  return (
    <div id="Spec" className="spec" ref={setTarget}>
      <div className="specTitleKR">기술 사양</div>
      <div className="specTitleEN">Specification</div>
      <div className="specline">
        <div className="specName">
          <p>제품명</p>
          <p>사이즈</p>
          <p>무게</p>
          <p>구성품</p>

          <p>소재</p>

          <p>작동 온도 범위</p>
          <p>최대 전압</p>
          <p>최대 출력</p>
          <p>모터 사양</p>
        </div>
        <div className="specContent">
          <p> TUF-350 (MK-1)</p>
          <p>350mm (D) x 190mm (H)</p>
          <p>4.7 kg</p>
          <p>
            TUF 본체, EPP 케이스, <br />
            사용설명서
          </p>
          <p>
            본체 - 알루미늄 및 스틸
            <br />
            케이스 -EPP
          </p>
          <p>250°C - 350°C</p>
          <p>14.4 V</p>
          <p>21.6 W</p>
          <p>24V / 8,000rpm</p>
        </div>
      </div>
    </div>
  );
};

export default Spec;
